<template>
  <div>
    <p>
      Create a new xinc project here!  
    </p>
    <form v-on:submit.prevent="submitProject">
      <p>Your Role:</p>
      <p>
        <input type="radio" id="project_role_client" v-model="project.role" value="client">
        <label for="project_role_client">Client</label>
        <input type="radio" id="project_role_contractor" v-model="project.role" value="contractor">
        <label for="project_role_contractor">Contractor</label>
      </p>
      <p>
        <label for="project_title">Title</label>
        <input class="form-control" id="project_title" type="text" v-model="project.title">
      </p>
      <p>
        <label for="project_recipient">Recipient</label>
        <input class="form-control" id="project_recipient " type="email" v-model="project.recipient">
      </p>
      <p>
        <textarea class="form-control" v-model="project.message" id="" cols="30" rows="10"></textarea>
      </p>
      <button class="btn btn-primary" type="submit">submit</button>
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import authService from '../auth'
import config from '../config'

export default {
  name: 'create',
  data () {
    return {
      project: {
        role: '',
        title: '',
        recipient: '',
        message: '',
        user: authService.user.uid
      }
    }
  },
  methods: {
    submitProject: function () {
      console.log(this.project)
      authService.user.getToken().then(token => {
        axios.post(
            `${config.base_url}/projects`,
            this.project,
            {headers: {'Authorization': token}}
        ).then(resp => {
          this.$router.push('/projects/' + resp.data.projects.id)
        }).catch(errors => {
          console.log(errors)
        })
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Create.vue?784d6222